// test985
(985 && 0);
